import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { AddShopMemberWithTokenDto } from "../generated/schema";

interface UseAddShopMemberParams {
  onSuccess: () => void;
  onError: () => void;
}

export default function useAddShopMembers(params: UseAddShopMemberParams) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const mutation = $api.useMutation("post", "/public/shops/{shopId}/members/token");

  return useMutation({
    onSuccess: () => {
      successNotification();
      params.onSuccess();
    },
    onError: () => {
      errorNotification();
      params.onError();
    },
    mutationFn: async ({ requestBody, shopId }: { requestBody: AddShopMemberWithTokenDto; shopId: string }) => {
      return mutation.mutateAsync({ params: { path: { shopId } }, body: requestBody });
    },
  });
}
